export default "__VITE_ASSET__DmrLKML5__"